// extracted by mini-css-extract-plugin
export var outcomeIcon = "SelectionIcon-module--outcomeIcon--beb67";